module.exports = __webpack_public_path__ + "img/logo.3826bb18.svg";